var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2224 0C24.1669 0 25.0002 0.833333 25.0002 1.83333V23.1111C25.0002 24.1111 24.1669 24.8889 23.2224 24.8889H1.83355C0.889106 24.8889 0.111328 24.1111 0.111328 23.1111V1.83333C0.111328 0.833333 0.889106 0 1.83355 0H23.2224ZM7.61133 21.3333V9.5H3.94466V21.3333H7.61133ZM5.77799 7.83333C6.94466 7.83333 7.88911 6.88889 7.88911 5.72222C7.88911 4.55556 6.94466 3.55556 5.77799 3.55556C4.55577 3.55556 3.61133 4.55556 3.61133 5.72222C3.61133 6.88889 4.55577 7.83333 5.77799 7.83333ZM21.4447 21.3333V14.8333C21.4447 11.6667 20.7224 9.16667 17.0002 9.16667C15.2224 9.16667 14.0002 10.1667 13.5002 11.1111H13.4447V9.5H9.94466V21.3333H13.6113V15.5C13.6113 13.9444 13.8891 12.4444 15.8336 12.4444C17.7224 12.4444 17.7224 14.2222 17.7224 15.5556V21.3333H21.4447Z",
    fill: "#B43A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5af3c217eb7e0c67c7043a3cd332a6de.svg";
export { ForwardRef as ReactComponent };